<template>
  <v-container fluid grid-list-xl>
    <MailClient></MailClient>
    <v-layout justify-center row wrap>
      <v-flex xs12 lg10>
        <h5 class="display-1 text-xs-center mb-3">
          <span class="font-weight-regular mb-2">Bienvenue {{ username }} </span>
          <span class="font-weight-light mb-2">Voici vos Curriculum Vitae </span>
        </h5>

        <!-- https://stackoverflow.com/questions/50172589/vuetify-transition-of-v-flex -->

        <v-flex mb-3>
          <v-card height="90px" color="cyan darken-2" hover>
            <v-card-text class="text-xs-center" primary-title>
              <div v-if="firstCvMsg" >
                <span><h6 class="title white--text"> Commencez à créer votre premier cv </h6></span>
              </div>

              <div>
                <v-btn
                  large

                  color="success"
                  v-on:click="addModelObject();">
                  Créer un nouveau cv
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>


        <transition-group name="list-item" tag="span" class="layout row wrap fill-height pa-2">
          <v-flex xs12 sm6 md4 lg4
                  v-for="(item, index) in modelObjects" :key="item.id"
          >
            <v-card height="600px" max-width="350px" hover>
              <v-card-title primary-title class="pb-0">
                <div>
                  <h3 class="headline mb-0">{{ item.name }}</h3>
                  <div>Date de création: {{ printTheDate(item.crea_date) }} <br> Dernière modification: {{ printTheDate(item.update_date) }} </div>
                </div>
              </v-card-title>

              <v-card-actions>
                 <v-dialog
                  v-model="dialog[item.id]"
                  :key="item.id"
                  max-width="500"
                >
                  <v-card>
                    <v-card-text class="headline grey lighten-2">
                      <p class="text-xs-center"> Supprimer ce CV?</p>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="warning"
                        @click="deleteModelObject(item.id, index), $set(dialog, item.id, false)"
                      >
                        Supprimer
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        @click="$set(dialog, item.id, false)"
                      >
                        Conserver
                      </v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <v-layout mb-3 align-center justify-space-around row fill-height>
                  <v-btn small color="warning" dark @click.stop="$set(dialog, item.id, true)">
                    <v-icon dark left>delete</v-icon>supprimer
                  </v-btn>
                  <v-btn small color="primary" dark @click="goToCvEdit(item.id)">
                    <v-icon dark left>edit</v-icon>Modifier
                  </v-btn>

                </v-layout>
              </v-card-actions>
              <v-divider></v-divider>
              <v-card-text>
                <v-img v-if="item.preview_img"
                       :src="item.preview_img"
                       max-height="420"
                       position="top center"
                ></v-img>
              </v-card-text>
            </v-card>
          </v-flex>
        </transition-group>
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>

 /*
    Attention :
    https://stackoverflow.com/questions/49580396/vuetify-how-to-open-and-close-dialogs-within-a-data-table
    Constatation si utilisation naive des v-dialog dans un v-for, on constate que les dialogs ne sont pas
    rattaché à leur item.id ==> cliquer sur confirmer pouvait donc supprimer un autre objets!!!!
    Voir changements sur ce commit.
  */

 import {  mapState } from 'vuex';
 import { mixin_ajax } from './mixin_ajax_vue.js';
 import session from '../api/session';
 import moment from 'moment';
 import MailClient from '../components/MailClient';

 export default {
   mixins: [mixin_ajax],
   components: {
     MailClient,
   },
   data: function() {
     return {
       dialog: {},
       api_url: '/api/cv/',
       modelObjects: [],
       isLoading: false,
       currentModelObject: {},
       message: null,
       newModelObject: function() {
         return {
           'owner': this.pk,
           // 'templates': [{
           // 'curriculum': 'daded72e-8662-4d0f-9576-ce836ff4391b',
           // 'template': 3,
           // }],
         }
       },
     }
   },
   methods:{
     printTheDate(theDate) {
       // affiche la date au format attendu par le datepicker (YYYY-MM-DD)
       // https://stackoverflow.com/questions/48427705/using-new-date-with-v-date-picker-doesnt-work Aldo Canepa
       if(theDate) {
         // console.log('MOMENT GETTER :::: ' + moment(theDate).format('YYYY-MM-DD'));
         return moment(theDate).format('DD/MM/YYYY');
       }
       else {
         // console.log("Pas de date")
         return
       }
     },
     goToCvEdit(cvId) {
       console.log("DEBUG!! le path : " + cvId);
       // autre façon mais limitée sur les params :
       // this.$router.push({path: `/cv/${cv_id}/edit`})
       this.$router.push({ name: 'cvEdit', params: { cv_id:cvId} })
     },
     getModelObjects: function() {
       /*
          S'il n'y a aucun cv de déjà créé, on en cré un automatiquement.
        */
       this.isLoading = true;
       session.get(this.api_url)
              .then((response) => {
                this.modelObjects = response.data;
                this.isLoading = false;
                console.log('GET CALLED : ' + this.api_url);
                console.log(response)
                if (response.data.length == 0) {
                  this.addModelObject()
                }
              })
              .catch((err) => {
                this.isLoading = false;
                if (err.response) {
                  // The request was made and the server responded with a status code
                  // that falls out of the range of 2xx
                  console.log('======= getModelObjects error in response =======')
                  console.log(err.response.data);
                  console.log(err.response.status);
                  console.log(err.response.headers);
                  console.log(err.response.headers);
                } else if (err.request) {
                  // The request was made but no response was received
                  // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                  // http.ClientRequest in node.js
                  console.log('======= getModelObjects error in request =======')
                  console.log(err.request);
                } else {
                  // Something happened in setting up the request that triggered an Error
                  console.log('======= getModelObjects error in else =======')
                  console.log('Err', err.message);
                }
              })
     },
     addModelObject() {
       /*
          On crée un cv ayant un template par defaut et
          on redirige immédiatement sur la page de sélection des template.
        */
       this.isLoading = true;
       console.log("Ajout d'une instance objectModel : ")
       console.log(this.newModelObject())
       var payload = this.newModelObject()
       // gestion de la protection csrf :
       // session.defaults.xsrfCookieName = 'csrftoken'
       // session.defaults.xsrfHeaderName = 'X-CSRFToken'
       session.post(this.api_url, payload)
                         .then((response) => {
                           this.isLoading = false;
                           console.log(response)
                           console.log('Added : ' + response.data)
                           // insère dans la liste la nouvelle structure (avec l'id) obtenue par le server REST :
                           // ajout a la fin
                           this.modelObjects.splice(this.modelObjects.length, 0, response.data)
                           // ajout au début :
                           // this.modelObjects.unshift(response.data)
                           // inutile de rappeller la regénération de la liste :
                           // this.getModelObjects();

                           var url_edit = '/cv/'+response.data.id+'/cvmodels'
                           console.log('URL EDIT : ' + url_edit)
                           // on redirige de suite vers le menu du choix du template.
                           this.$router.push(url_edit)
                         })
                         .catch((err) => {
                           this.isLoading = false;
                           console.log(err.response);
                         })
     },
   },


   // permet d'accéder au store
   computed: {
     ...mapState('whoami', [
       'pk',
       'username',
       'email',
       'first_name',
       'last_name',
     ]),
     firstCvMsg() {
       if(this.modelObjects.length === 0) {
         return true;
       }
       else {
         return false;
       }
     },
   },




 }

</script>

<style>
.list-item-enter, .list-item-leave-to /* .list-leave-active for <2.1.8 */ {
  opacity: 0;
  transform: scale(0.5);
}

.list-item-move {
    transition: transform 1s;
    }

.list-item-enter-active, .list-item-leave-active {
  transition: opacity 0.3s, transform 0.3s;
  transform-origin: left center;
}
</style>
